import { useTranslation } from "react-i18next";

function SectionFamilyCare() {
  const { t } = useTranslation();

  return (
    <section id="about" className="bg-[#E6F3EA] py-10 px-6 md:py-16 md:px-24 text-center">
      <h1 className="font-[CormorantGaramond] text-[38px] md:text-[46px] font-bold">
        {t('landing.familyCare.title')}
      </h1>
      <p className="mt-3 mb-8">
        {t('landing.familyCare.subtitle')}
      </p>
      <div className="flex flex-col text-white md:flex-row md:justify-space-between place-self-center">
        <div className="bg-[#0D7330] py-6 px-6 mb-4 md:mb-0 md:mr-6 rounded-lg w-full md:w-1/3 md:max-w-[400px]">
          <div className="font-[CormorantGaramond] font-bold text-2xl pb-3 border-b-1 border-[#E6F3EA] mb-3">
            {t('landing.familyCare.card1.title')}
          </div>
          <p className="text-sm">
            {t('landing.familyCare.card1.description')}
          </p>
        </div>
        <div className="bg-[#0D7330] py-6 px-6 mb-4 md:mb-0 md:mr-6 rounded-lg w-full md:w-1/3 md:max-w-[400px]">
          <div className="font-[CormorantGaramond] font-bold text-2xl pb-3 border-b-1 border-[#E6F3EA] mb-3">
            {t('landing.familyCare.card2.title')}
          </div>
          <p className="text-sm">
            {t('landing.familyCare.card2.description')}
          </p>
        </div>
        <div className="bg-[#0D7330] py-6 px-6 rounded-lg w-full md:w-1/3 md:max-w-[400px]">
          <div className="font-[CormorantGaramond] font-bold text-2xl pb-3 border-b-1 border-[#E6F3EA] mb-3">
            {t('landing.familyCare.card3.title')}
          </div>
          <p className="text-sm">
            {t('landing.familyCare.card3.description')}
          </p>
        </div>
      </div>
    </section>
  );
}

export default SectionFamilyCare;
